import { render, staticRenderFns } from "./CalendarClassSchedules.vue?vue&type=template&id=fbd673d4"
import script from "./CalendarClassSchedules.vue?vue&type=script&lang=js"
export * from "./CalendarClassSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports